import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

// Prilagođeni podaci servera za 7-all.com
const serverLinks = [
  {
    id: 1,
    name: "7-all.com Web",
    description: "Glavna web stranica",
    port: 443,
    icon: "🌐",
    url: "https://7-all.com/",
  },
  {
    id: 2,
    name: "Matrix Server",
    description: "Hetzner panel",
    port: 8448,
    icon: "💬",
    url: "https://accounts.hetzner.com/login",
  },
  {
    id: 3,
    name: "Nginx UI",
    description: "Nginx upravljanje",
    port: 8090,
    icon: "🔌",
    url: "https://nginx-ui.7-all.com/#/dashboard/sites",
  },
  {
    id: 4,
    name: "PROFESOR",
    description: "Prevodilac platforma",
    port: 443,
    icon: "📊",
    url: "https://profesor.7-all.com/",
  },
  {
    id: 5,
    name: "Monitoring",
    description: "Netdata metrike",
    port: 19999,
    icon: "📈",
    url: "https://netdata.7-all.com",
  },
  {
    id: 6,
    name: "Server Admin",
    description: "Majstor panel",
    port: 8080,
    icon: "🖥️",
    url: "https://majstor.7-all.com/",
  },
];

const ServerLinks = () => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
      {serverLinks.map((server) => (
        <a
          key={server.id}
          href={server.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block hover:scale-105 transition-transform hover:shadow-lg"
        >
          <Card className="h-full bg-black/30 backdrop-blur-sm border border-primary/20 hover:border-primary/50 transition-colors">
            <CardHeader className="pb-2">
              <CardTitle className="flex items-center text-lg">
                <span className="mr-2 text-2xl">{server.icon}</span>
                {server.name}
              </CardTitle>
              <CardDescription>Port: {server.port}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">{server.description}</p>
            </CardContent>
          </Card>
        </a>
      ))}
    </div>
  );
};

export default ServerLinks;
